<template>
  <div class="bg-white border border-black/6 rounded-[16px] p-3 shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-[box-shadow,border-color] duration-200 hover:border-black/8 hover:shadow-[0_4px_12px_rgba(0,0,0,0.07)]">
    <p class="text-[11px] font-semibold uppercase tracking-wide text-primary mb-1 mt-0">{{ task.applicant }}</p>
    <p class="text-[13px] font-medium text-ink leading-snug m-0">{{ task.title }}</p>
    <div class="flex items-center justify-between mt-2.5">
      <div v-if="task.assignedTo" class="flex">
        <div v-for="person in getAssignedTo(task.assignedTo).split(',')" :key="person" class="-ml-1 first:ml-0">
          <img v-if="getPersonPhoto(person.trim())" class="w-[22px] h-[22px] rounded-full border-2 border-white object-cover block" :src="getPersonPhoto(person.trim())" :title="person.trim()" :alt="person.trim()">
        </div>
      </div>
      <span v-if="task.deadline" class="text-xs whitespace-nowrap" :class="isOverdue ? 'text-[#e53935] font-medium' : 'text-muted'">
        {{ task.deadline | formatDate }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getAssignedToText } from '@/services/applicant-helpers'
import { PHOTOS } from '@/services/photos'

export default {
  name: 'SingleTaskCard',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      managers: state => state.managers.managers
    }),
    isOverdue () {
      if (!this.task.deadline) return false
      return new Date(this.task.deadline) < new Date()
    }
  },
  methods: {
    getAssignedTo (people) {
      return getAssignedToText(people, this.managers)
    },
    getPersonPhoto (name) {
      return PHOTOS[name.toLowerCase()] || null
    }
  }
}
</script>
